import { Action } from '@ngrx/store'

import { Facet } from '../../facets/models/facet';
import { FacetGroup } from '../../facets/models/facet-group'
import { FacetCount } from '../../facets/models/facet-count'
import { AppliedFacets } from '../../facets/models/applied-facets';

export const INIT_GROUPS = '[Facets] Init Groups'
export const GET_GROUPS = '[Facets] Get Groups'
export const GET_GROUPS_SKIPPED = '[Facets] Get Groups Skipped'
export const GET_GROUPS_SUCCES = '[Facets] Get Groups Success'
export const GET_GROUPS_FAILED = '[Facets] Get Groups Failed'

export const INIT_FACETS = '[Facets] Init Facets'
export const GET_FACETS = '[Facets] Get Facets'
export const GET_FACETS_SKIPPED = '[Facets] Get Facets Skipped'
export const GET_FACETS_SUCCESS = '[Facets] Get Facets Success'
export const GET_FACETS_FAILED = '[Facets] Get Facets Failed'

export const APPLY = '[Facets] Apply'

export const FILTER = '[Facets] Filter'
export const FILTER_SUCCESS = '[Facets] Filter Success'
export const FILTER_FAILED = '[Facets] Filter Failed'
export const FILTER_RESET = '[Facets] Filter Reset'

export const SHOW_MORE = '[Facets] Show More'

export class InitGroups implements Action {
    readonly type = INIT_GROUPS
    constructor(public forceRefresh: boolean = false) {}
}
export class GetGroupsSkipped implements Action {
  readonly type = GET_GROUPS_SKIPPED
}
export class GetGroups implements Action {
  readonly type = GET_GROUPS
}
export class GetGroupsSuccess implements Action {
    readonly type = GET_GROUPS_SUCCES
    constructor(public payload: FacetGroup[]) {}
}
export class GetGroupsFailed implements Action {
    readonly type = GET_GROUPS_FAILED
    constructor(public payload: any | null) {}
}
export class InitFacets implements Action {
    readonly type = INIT_FACETS
    constructor(public forceRefresh: boolean = false) {}
}
export class GetFacetsSkipped implements Action {
  readonly type = GET_FACETS_SKIPPED
}
export class GetFacets implements Action {
  readonly type = GET_FACETS
}
export class GetFacetsSuccess implements Action {
    readonly type = GET_FACETS_SUCCESS
    constructor(public payload: Facet[]) {}
}
export class GetFacetsFailed implements Action {
    readonly type = GET_FACETS_FAILED
    constructor(public payload: any | null) {}
}
export class Apply implements Action {
    readonly type = APPLY

    constructor(public payload: AppliedFacets) {}
}
export class Filter implements Action {
    readonly type = FILTER
}
export class FilterSuccess implements Action {
    readonly type = FILTER_SUCCESS

    constructor(public payload: FacetCount[]) {}
}
export class FilterFailed implements Action {
    readonly type = FILTER_FAILED

    constructor(public payload: any | null) {}
}
export class FilterReset implements Action {
  readonly type = FILTER_RESET
}
export class ShowMore implements Action {
    readonly type = SHOW_MORE

    constructor(public payload: string) {}
}

export type Actions =
    InitGroups
    | GetGroupsSkipped
    | GetGroups
    | GetGroupsSuccess
    | GetGroupsFailed
    | InitFacets
    | GetFacetsSkipped
    | GetFacets
    | GetFacetsSuccess
    | GetFacetsFailed
    | Apply
    | Filter
    | FilterSuccess
    | FilterFailed
    | FilterReset
    | ShowMore
